export default __webpack_public_path__ + "static/media/municipio.22455fa1.svg";